export class EnvService {

  public SiteKeyGoogle = '';

  public apiMutualCertification = '';

  public TipoCaptcha = '';

  constructor() {
  }

}
